module.exports = "/images/pn.svg?be6761bcae6240c661e56680e93ef56c";